export default "__VITE_ASSET__CtOB2O$Y__"